import { DEFAULT_HEADERS } from '../constants/index.js';
export const getBearerHeaders = (token) => {
    return {
        ...DEFAULT_HEADERS,
        Authorization: `Bearer ${token}`,
    };
};
//# sourceMappingURL=bearer-token-headers.js.map